/* tslint:disable */
/* eslint-disable */
/**
 * Selling Partner API for Pricing
 * The Selling Partner API for Pricing helps you programmatically retrieve product pricing and offer information for Amazon Marketplace products.
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Filters the offer listings to be considered based on item condition. Possible values: New, Used, Collectible, Refurbished, Club.
 */

export const ItemCondition = {
    New: 'New',
    Used: 'Used',
    Collectible: 'Collectible',
    Refurbished: 'Refurbished',
    Club: 'Club',
} as const;

export type ItemCondition = typeof ItemCondition[keyof typeof ItemCondition];



